import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useState } from 'react';
import { Box, Fab } from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import LoginPage from './components/auth/LoginPage';
import RegisterPage from './components/auth/RegisterPage';
import Products from './components/ProductList';
import MyLinks from './components/Products/MyLinks/MyLinks';
import ClubeDashboard from './components/Products/ClubeDeMesa/ClubeDashboard';
import Surpresa from './components/Surpresa/Surpresa';
import PrivateRoute from './components/common/PrivateRoute';
import RestaurantSwitcher from './components/common/RestaurantSwitcher';
import SessionGuard from './components/common/SessionGuard';
import SupportBotWidget from './components/common/SupportBotWidget';
import IfoodConnectionPage from './components/settings/IfoodConnectionPage';
import InitialSetupPage from './components/onboarding/InitialSetupPage';

import ReservoRoutes from './Routes/ReservoRoutes';
import AtendabotRoutes from './Routes/AtendabotRoutes';
import ManagerRoutes from './Routes/ManagerRoutes';
import ChecklistRoutes from './Routes/ChecklistRoutes';
import CardapioRoutes from './Routes/CardapioRoutes';
import FoodserviceFormRoutes from './Routes/FoodserviceFormRoutes';
import CvRoutes from './Routes/CvRoutes';
import ConfereAIRoutes from './Routes/ConfereAIRoutes';
import FeedbackHeroRoutes from './Routes/FeedbackHeroRoutes';
import FinanceiroRoutes from './Routes/FinanceiroRoutes';
import CrmRoutes from './Routes/CrmRoutes';
import FoodstationLinksRoutes from './Routes/FoodstationLinksRoutes';
import PublicLinksWrapper from './components/Products/FoodstationLinks/PublicLinksWrapper.jsx';
import WhatsAppProspectPreview from './components/WhatsAppProspectPreview/WhatsAppProspectPreview.jsx';
import PublicReservoWrapper from './components/Products/Reservo/PublicReservoWrapper.tsx';
import PublicWaitlistWrapper from './components/Products/Reservo/PublicWaitlistWrapper.tsx';
import PublicReservaManageWrapper from './components/Products/Reservo/PublicReservaManageWrapper.tsx';
import UnitsPage from './components/Units/UnitsPage';
import UnitForm from './components/Units/UnitForm';
import UsersPage from './components/Users/UsersPage';
import UserForm from './components/Users/UserForm';
import SmartRoutes from './Routes/SmartRoutes';

// --- IMPORTS PARA O FLUXO PÚBLICO DO CV ---
import JobApplication from './components/Products/Cv/pages/JobApplication';
import ApplicationSuccess from './components/Products/Cv/pages/ApplicationSuccess';
import ApplicationStatus from './components/Products/Cv/pages/ApplicationStatus';
import PublicJobs from './components/Products/Cv/pages/PublicJobs'; // Adicionado

import SmartCampaignsDashboard from './components/Products/SmartCampaigns/SmartCampaignsDashboard';
import { CheckinCardapioRedirect } from './Routes/CardapioRoutes';
import CheckinClosed from './components/Products/ClubeDeMesa/CheckinClosed';
import FoodstationLP from './components/FoodstationLP/FoodstationLP';
import AtendabotLP from './components/AtendabotInstitutional/AtendabotLP';
import AtendabotLanding, {
  AtendabotAccessUnavailable,
} from './components/AtendabotLanding/AtendabotLanding';
import ReservoLP from './components/ReservoLP/ReservoLP';
import CheckoutSuccess from './components/billing/CheckoutSuccess';
import CheckoutCancelled from './components/billing/CheckoutCancelled';
import BillingRequired from './components/billing/BillingRequired';
import RestaurantInactive from './components/billing/RestaurantInactive';
import AccountOverview from './components/billing/AccountOverview';
import ChangePasswordPage from './components/account/ChangePasswordPage';
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import TermsOfUse from './components/Legal/TermsOfUse';

import { ToastContainer } from 'react-toastify';
import { useBranding } from './branding/BrandingContext';
import 'react-toastify/dist/ReactToastify.css';
import CustomerForm from './components/Products/FeedbackForm/pages/CustomerForm';
import useMetaPageView from './hooks/useMetaPageView';
import { useAuthSession } from './contexts/AuthSessionContext';
import { ATENDABOT_PRODUCT_IMAGE, PRODUCT_IMAGES } from './branding/assets';

const produtos = [

  {
    nome: 'atendabot',
    imagem: ATENDABOT_PRODUCT_IMAGE,
    backgroundColor: '#3127A0',
    link: '/atendabot',
    logoSize: '200px',
    productKey: 'atendabot',
  },

  {
    nome: 'LinkPage',
    imagem: PRODUCT_IMAGES.linkPage,
    backgroundColor: '#f4f6f8',
    link: '/links',
    logoSize: '260px',
    productKey: 'linkpage',
  },

  {
    nome: 'One Menu',
    imagem: PRODUCT_IMAGES.oneMenu,
    backgroundColor: '#fdf3e4',
    link: '/cardapio',
    logoSize: '210px',
    productKey: 'cardapio',
  },

  {
    nome: 'Clube de Mesa',
    imagem: PRODUCT_IMAGES.clube,
    backgroundColor: '#F0E6DC',
    link: '/clube',
    logoSize: '250px',
    productKey: 'clube_mesa',
  },

  {
    nome: "Feedback Hero",
    imagem: PRODUCT_IMAGES.feedbackHero,
    backgroundColor: "#143023",
    link: "/feedback-hero",
    logoSize: "250px",
    productKey: 'feedback_hero',
  },

  {
    nome: 'ClientCenter CRM',
    imagem: PRODUCT_IMAGES.clientCenter,
    backgroundColor: '#fbfbfc',
    link: '/crm',
    logoSize: '350px',
    productKey: 'crm',
  },

  {
    nome: 'ChefList',
    imagem: PRODUCT_IMAGES.chefList,
    backgroundColor: '#fcfefe',
    link: '/checklist',
    logoSize: '250px',
    productKey: 'checklist',
  },

  {
    nome: 'CurrículoCerto',
    imagem: PRODUCT_IMAGES.cv,
    backgroundColor: '#000',
    link: '/cv',
    logoSize: '140px',
    productKey: 'cv',
  },

  {
    nome: 'Reservo',
    imagem: PRODUCT_IMAGES.reservo,
    backgroundColor: '#ffdb2f',
    link: '/reservo',
    logoSize: '250px',
    productKey: 'reservo',
  },

  {
    nome: 'Smart Campaigns',
    imagem: PRODUCT_IMAGES.smartCampaigns,
    backgroundColor: '#ff6600',
    link: '/smart',
    logoSize: '140px',
    productKey: 'smart',
  },

  {
    nome: 'ConfereAI',
    imagem: PRODUCT_IMAGES.confereAi,
    backgroundColor: '#f46d6b',
    link: '/confereai',
    logoSize: '200px',
    productKey: 'confereai',
  },

];

const ATENDABOT_BRAND_EXACT_PATHS = new Set([
  '/',
  '/login',
  '/restaurante-inativo',
]);

const isPathWithin = (pathname, prefix) => (
  pathname === prefix || pathname.startsWith(`${prefix}/`)
);

const normalizeRoutePath = (pathname = '/') => {
  const normalized = String(pathname || '/').replace(/\/+$/, '');
  return normalized || '/';
};

const isAtendabotBrandPathAllowed = (pathname) => {
  const normalizedPathname = normalizeRoutePath(pathname);

  return ATENDABOT_BRAND_EXACT_PATHS.has(normalizedPathname)
    || isPathWithin(normalizedPathname, '/atendabot')
    || isPathWithin(normalizedPathname, '/billing');
};

const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    session,
    isAuthenticated,
    isHydrating,
    isAdmin,
    isFoodUser,
    hasBillingAccess,
    hasRestaurantAccess,
    hasProductAccess,
    getProductEntryPath,
  } = useAuthSession();
  useMetaPageView();
  const [expanded, setExpanded] = useState(false);
  const [isFloatingTriggerHovered, setIsFloatingTriggerHovered] = useState(false);
  const branding = useBranding();
  const isFoodstationLanding =
    branding?.landingVariant === 'foodstation' || branding?.key === 'foodstation';
  const isAtendabotBrand =
    branding?.landingVariant === 'atendabot' || branding?.key === 'atendabot';

  const billingAllowed = hasBillingAccess;
  const atendabotProductKey = branding?.productKey || 'atendabot';
  const hasAtendabotAccess = Boolean(
    isAtendabotBrand
    && session
    && hasProductAccess(atendabotProductKey, { allowTrialRestricted: true })
  );
  let atendabotAuthenticatedPath = branding?.authenticatedPath || '/atendabot';

  if (isAtendabotBrand && session) {
    if (!billingAllowed) {
      atendabotAuthenticatedPath = '/billing';
    } else if (!hasRestaurantAccess) {
      atendabotAuthenticatedPath = '/restaurante-inativo';
    } else if (!hasAtendabotAccess) {
      atendabotAuthenticatedPath =
        branding?.accessDeniedPath || '/atendabot/acesso-indisponivel';
    } else {
      atendabotAuthenticatedPath = getProductEntryPath(
        atendabotProductKey,
        branding?.authenticatedPath || '/atendabot'
      );
    }
  }

  const normalizedCurrentPath = normalizeRoutePath(location.pathname);
  const normalizedAccessDeniedPath = normalizeRoutePath(
    branding?.accessDeniedPath || '/atendabot/acesso-indisponivel'
  );
  const normalizedAuthenticatedPath = normalizeRoutePath(atendabotAuthenticatedPath);

  if (
    isAtendabotBrand
    && normalizedCurrentPath === normalizedAccessDeniedPath
    && location.pathname !== normalizedAccessDeniedPath
  ) {
    return <Navigate to={normalizedAccessDeniedPath} replace />;
  }

  if (
    isAtendabotBrand
    && isAuthenticated
    && !isHydrating
    && session
    && normalizedCurrentPath === normalizedAccessDeniedPath
    && normalizedAuthenticatedPath !== normalizedAccessDeniedPath
  ) {
    return <Navigate to={atendabotAuthenticatedPath} replace />;
  }

  if (isAtendabotBrand && !isAtendabotBrandPathAllowed(location.pathname)) {
    if (isHydrating) return null;

    return (
      <Navigate
        to={isAuthenticated && session ? atendabotAuthenticatedPath : '/'}
        replace
      />
    );
  }

  let lista = produtos.filter((p) => {
    if (!session) return false;
    if (!billingAllowed) return false;
    if (p.adminOnly && !isAdmin) return false;
    return hasProductAccess(p.productKey, { allowTrialRestricted: true });
  });

  // Add Manager for admin users
  if (isAdmin) {
    lista.unshift({
      nome: 'Manager',
      imagem: null,
      backgroundColor: '#DC3545', // Red color for admin
      link: '/manager',
      logoSize: '200px',
      productKey: null,
      adminOnly: true,
    });
  }

  // Define public routes that don't require login
  const publicRoutes = [
    '/',
    '/login',
    '/cadastro',
    '/surpresa',
    '/billing',
    '/billing/success',
    '/billing/cancelled',
    '/restaurante-inativo',
    '/politica-de-privacidade',
    '/termos-de-uso',
    '/pesquisa',
    '/checkin/cardapio',
    '/checkin/fechado',
    '/reservar',
    '/fila',
    '/reserva',
    '/cv/vagas',
    '/cv/aplicar',
    '/cv/successo',
    '/cv/application-success', // ✅ ROTA ALIAS ADICIONADA
    '/cv/status',
    '/lp/atendabot',
    '/lp/reservo',
    '/bio'
  ];
  const sessionGuardSkipRoutes = [
    '/',
    '/login',
    '/cadastro',
    '/surpresa',
    '/billing/success',
    '/billing/cancelled',
    '/politica-de-privacidade',
    '/termos-de-uso',
    '/pesquisa',
    '/checkin/cardapio',
    '/checkin/fechado',
    '/reservar',
    '/fila',
    '/reserva',
    '/cv/vagas',
    '/cv/aplicar',
    '/cv/successo',
    '/cv/application-success',
    '/cv/status',
    '/lp/atendabot',
    '/lp/reservo',
    '/bio',
  ];

  // Check if current route is public
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const isPublicCardapioSlugRoute = pathSegments[0] === 'cardapio'
    && pathSegments.length === 2
    && pathSegments[1] !== 'tags'
    && pathSegments[1] !== 'checkin'
    && pathSegments[1] !== 'ifood';
  const isPublicLinkPageSlugRoute = pathSegments[0] === 'links'
    && (
      pathSegments.length === 2
      || (pathSegments.length === 3 && pathSegments[1] === 'preview')
    );
  const isPublicRoute = isPublicCardapioSlugRoute || isPublicLinkPageSlugRoute || publicRoutes.some(route =>
    location.pathname === route || location.pathname.startsWith(route + '/')
  );
  const shouldSkipSessionGuard = isPublicCardapioSlugRoute || isPublicLinkPageSlugRoute || sessionGuardSkipRoutes.some(route =>
    location.pathname === route || location.pathname.startsWith(route + '/')
  );
  const isReservoAdminRoute = location.pathname === '/reservo'
    || location.pathname.startsWith('/reservo/');
  const shouldHideFloatingProductMenu = isReservoAdminRoute
    || location.pathname === '/cv'
    || location.pathname.startsWith('/cv/')
    || location.pathname === '/feedback-hero'
    || location.pathname.startsWith('/feedback-hero/')
    || location.pathname === '/cardapio/ifood';
  const isFloatingTriggerVisible = isFloatingTriggerHovered || expanded;
  const handleToggleExpanded = () => setExpanded(prev => !prev);
  const floatingTriggerTop = 110;
  const floatingMenuTop = floatingTriggerTop + 74;
  const floatingMenuRight = 18;

  return (
    <>
      {!isAtendabotBrand && <RestaurantSwitcher />}
      <SessionGuard enabled={!shouldSkipSessionGuard} />
      <Routes>
        <Route path="/pesquisa" element={<CustomerForm />} />
        {/* === ROTAS PÚBLICAS (sem PrivateRoute) === */}
        <Route
          path="/"
          element={
            isHydrating
              ? null
              : (isAuthenticated && session
                ? <Navigate
                    to={isAtendabotBrand ? atendabotAuthenticatedPath : '/products'}
                    replace
                  />
                : (isFoodstationLanding
                  ? <FoodstationLP />
                  : (isAtendabotBrand
                    ? <AtendabotLanding />
                    : <Navigate to="/login" replace />)))
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/cadastro" element={<RegisterPage />} />
        <Route path="/billing/success" element={<CheckoutSuccess />} />
        <Route path="/billing/cancelled" element={<CheckoutCancelled />} />
        <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
        <Route path="/termos-de-uso" element={<TermsOfUse />} />
        <Route path="/surpresa" element={<Surpresa />} />
        <Route path="/checkin/cardapio/:slug" element={<CheckinCardapioRedirect />} />
        <Route path="/checkin/fechado" element={<CheckinClosed />} />
        <Route path="/reservar/:slug_restaurante" element={<PublicReservoWrapper />} />
        <Route path="/fila/:slug_restaurante" element={<PublicWaitlistWrapper />} />
        <Route path="/links/:slug" element={<PublicLinksWrapper />} />
        <Route path="/links/preview/:prospectName" element={<PublicLinksWrapper preview />} />
        <Route path="/preview/whatsapp/:prospectName" element={<WhatsAppProspectPreview />} />
        <Route path="/bio/:slug" element={<PublicLinksWrapper />} />
        <Route path="/lp/atendabot" element={<AtendabotLP />} />
        <Route path="/lp/reservo" element={<ReservoLP />} />
        <Route path="/reserva/:token" element={<PublicReservaManageWrapper />} />
        
        {/* --- ROTAS PÚBLICAS DO CV --- */}
        <Route path="/cv/vagas/:slug" element={<PublicJobs />} />
        <Route path="/cv/aplicar/:jobId" element={<JobApplication />} />
        <Route path="/cv/successo" element={<ApplicationSuccess />} />
        {/* ✅ ROTA ALIAS ADICIONADA PARA COMPATIBILIDADE COM O JobApplication.jsx */}
        <Route path="/cv/application-success" element={<ApplicationSuccess />} />
        <Route path="/cv/status/:applicationId" element={<ApplicationStatus />} />


        {/* === ROTAS PRIVADAS (protegidas pelo PrivateRoute) === */}
        <Route path="/products" element={
          <PrivateRoute>
            <Products />
          </PrivateRoute>
        } />
        <Route path="/setup-inicial" element={
          <PrivateRoute ownerOnly skipBilling>
            <InitialSetupPage />
          </PrivateRoute>
        } />
        <Route path="/products/my-links" element={
          <PrivateRoute>
            <MyLinks />
          </PrivateRoute>
        } />
        <Route path="/billing" element={
          <PrivateRoute skipBilling skipRestaurantCheck>
            <BillingRequired />
          </PrivateRoute>
        } />
        <Route path="/billing/*" element={<Navigate to="/billing" replace />} />
        <Route path="/restaurante-inativo" element={
          <PrivateRoute skipBilling skipRestaurantCheck>
            <RestaurantInactive />
          </PrivateRoute>
        } />
        <Route path="/conta" element={
          <PrivateRoute ownerOnly skipBilling>
            <AccountOverview />
          </PrivateRoute>
        } />
        <Route path="/alterar-senha" element={
          <PrivateRoute skipBilling skipRestaurantCheck>
            <ChangePasswordPage />
          </PrivateRoute>
        } />
        <Route path="/configuracoes/ifood" element={
          <PrivateRoute skipBilling>
            <IfoodConnectionPage />
          </PrivateRoute>
        } />
        <Route path="/configurações/ifood" element={<Navigate to="/configuracoes/ifood" replace />} />
        <Route path="/configuracoes/*" element={<Navigate to="/products" replace />} />
        <Route path="/unidades" element={
          <PrivateRoute ownerOnly>
            <UnitsPage />
          </PrivateRoute>
        } />
        <Route path="/unidades/novo" element={
          <PrivateRoute ownerOnly>
            <UnitForm />
          </PrivateRoute>
        } />
        <Route path="/unidades/:id" element={
          <PrivateRoute ownerOnly>
            <UnitForm />
          </PrivateRoute>
        } />
        <Route path="/usuarios" element={
          <PrivateRoute ownerOnly allowAtendabotManager>
            <UsersPage />
          </PrivateRoute>
        } />
        <Route path="/usuarios/novo" element={
          <PrivateRoute ownerOnly allowAtendabotManager>
            <UserForm />
          </PrivateRoute>
        } />
        <Route path="/usuarios/:id" element={
          <PrivateRoute ownerOnly allowAtendabotManager>
            <UserForm />
          </PrivateRoute>
        } />
        <Route path="/clube" element={
          <PrivateRoute product="clube_mesa">
            <ClubeDashboard />
          </PrivateRoute>
        } />
        <Route path="/feedback-hero/*" element={<FeedbackHeroRoutes />} />

        <Route path="/smart" element={
          <PrivateRoute product="smart">
            <SmartCampaignsDashboard />
          </PrivateRoute>
        } />
        <Route path="/smart/*" element={<SmartRoutes />} />

        {/* Sub-rotas agrupadas e protegidas */}
        <Route path="/reservo/*" element={
          <PrivateRoute product="reservo">
            <ReservoRoutes />
          </PrivateRoute>
          } />

        <Route path="/atendabot/acesso-indisponivel" element={
          <PrivateRoute skipBilling skipRestaurantCheck>
            <AtendabotAccessUnavailable />
          </PrivateRoute>
        } />
        <Route path="/atendabot/*" element={<AtendabotRoutes />} />
        <Route path="/foodservice-form/*" element={<FoodserviceFormRoutes />} />
        <Route path="/checklist/*" element={<ChecklistRoutes />} />
        <Route path="/cardapio/*" element={<CardapioRoutes />} />
        <Route path="/financeiro/*" element={<FinanceiroRoutes />} />
        <Route path="/crm/*" element={<CrmRoutes />} />
        <Route path="/links/*" element={<FoodstationLinksRoutes />} />

        {/* --- ROTA PRIVADA PARA O DASHBOARD DE ADMIN DO CV --- */}
        <Route path="/cv/*" element={
          <PrivateRoute product="cv">
            <CvRoutes />
          </PrivateRoute>
        } />

        {/* --- ROTA PRIVADA PARA O CONFEREAI --- */}
        <Route path="/confereai/*" element={
          <PrivateRoute product="confereai">
            <ConfereAIRoutes />
          </PrivateRoute>
        } />

        <Route path="/manager/*" element={
          <PrivateRoute adminOnly>
            <ManagerRoutes />
          </PrivateRoute>
          } />

      </Routes>
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      <SupportBotWidget />
      {!isAtendabotBrand && !isPublicRoute && location.pathname !== '/products' && !shouldHideFloatingProductMenu && isFoodUser !== false && billingAllowed && (
        <>
          <Box
            sx={{
              position: 'fixed',
              top: floatingTriggerTop,
              right: 0,
              zIndex: 1301,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              pr: 0,
            }}
            onMouseEnter={() => setIsFloatingTriggerHovered(true)}
            onMouseLeave={() => setIsFloatingTriggerHovered(false)}
          >
            <Fab
              size="large"
              onClick={handleToggleExpanded}
              sx={{
                background: 'linear-gradient(45deg, #007BFF 30%, #0056b3 90%)',
                color: 'white',
                boxShadow: '0 4px 12px rgba(0, 123, 255, 0.3)',
                transform: isFloatingTriggerVisible ? 'translateX(0)' : 'translateX(145%)',
                opacity: isFloatingTriggerVisible ? 1 : 0,
                transition: 'transform 0.25s ease, opacity 0.25s ease',
                pointerEvents: isFloatingTriggerVisible ? 'auto' : 'none',
                '&:hover': {
                  background: 'linear-gradient(45deg, #0056b3 30%, #003d82 90%)',
                  boxShadow: '0 6px 16px rgba(0, 123, 255, 0.4)',
                }
              }}
              aria-label="products"
            >
              <AppsIcon />
            </Fab>
            <Box
              role="button"
              tabIndex={0}
              aria-label="Mostrar botão de produtos"
              onClick={handleToggleExpanded}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleToggleExpanded();
                }
              }}
              sx={{
                width: 12,
                height: 52,
                borderRadius: '14px 0 0 14px',
                background: 'linear-gradient(180deg, #4db2ff 0%, #0a7cff 42%, #0050a8 100%)',
                border: '1px solid rgba(255, 255, 255, 0.42)',
                borderRight: 'none',
                boxShadow: '-8px 0 16px rgba(0, 123, 255, 0.34), inset 1px 0 0 rgba(255, 255, 255, 0.36)',
                position: 'relative',
                cursor: 'pointer',
                opacity: isFloatingTriggerVisible ? 0 : 1,
                transform: isFloatingTriggerVisible ? 'translateX(8px) scaleX(0.7)' : 'translateX(0) scaleX(1)',
                pointerEvents: isFloatingTriggerVisible ? 'none' : 'auto',
                transition: 'opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 10,
                  left: 3,
                  width: 3,
                  height: 30,
                  borderRadius: '999px',
                  backgroundColor: 'rgba(255, 255, 255, 0.45)',
                },
                '&:hover': {
                  boxShadow: '-10px 0 20px rgba(0, 123, 255, 0.45), inset 1px 0 0 rgba(255, 255, 255, 0.45)',
                },
                '&:focus-visible': {
                  outline: '2px solid #0056b3',
                  outlineOffset: 2,
                }
              }}
            />
          </Box>
          <Box sx={{
            position: 'fixed',
            top: floatingMenuTop,
            right: floatingMenuRight,
            zIndex: 1300,
            opacity: expanded ? 1 : 0,
            transform: expanded ? 'translateY(0)' : 'translateY(-20px)',
            transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
            pointerEvents: expanded ? 'auto' : 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
          onClick={(e) => e.stopPropagation()}
          >
            {lista.map((produto, index) => (
              <Box
                key={index}
                onClick={() => {
                  navigate(getProductEntryPath(produto.productKey, produto.link));
                  setExpanded(false);
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 1,
                  cursor: 'pointer',
                  transform: expanded ? 'translateY(0)' : 'translateY(-20px)',
                  opacity: expanded ? 1 : 0,
                  transition: `all 0.3s ease-in-out ${index * 0.1}s`,
                  '&:hover': { opacity: 0.8 }
                }}
              >
                <span style={{
                  marginRight: 10,
                  color: '#333',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}>
                  {produto.nome}
                </span>
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    backgroundColor: produto.backgroundColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'scale(1.1)',
                    }
                  }}
                >
                  {produto.imagem ? (
                    <img
                      src={produto.imagem}
                      alt={produto.nome}
                      style={{
                        width: 40,
                        height: 40,
                        objectFit: 'contain',
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        color: 'white',
                        fontSize: '24px',
                        fontWeight: 'bold',
                      }}
                    >
                      M
                    </Box>
                  )}
                </Box>
              </Box>
            ))}
          </Box>
          {expanded && (
            <Box
              onClick={() => setExpanded(false)}
              sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(255,255,255,0.2)',
                backdropFilter: 'blur(3px)',
                zIndex: 1200,
                pointerEvents: 'auto',
              }}
            />
          )}
        </>
      )}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;